/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  appname: 'Líder da Própria Evolução',
  urlbase: 'https://api-lpe.entregadigital.app.br/api/v1/pwa/',

  ds: '&dM4_', // Descryptor Hash

  oneSignalAppID: '',
  oneSignalSafariWebID: '',
  subdomainName: '',




  version:'1.0.8',
  disableDevToolsDetector: false,
};
